import * as Styled from "styles/components/common/SplashStyle";
import logo from "assets/logo.svg";

const Splash = () => {
  return (
    <Styled.Splash>
      <img src={logo} alt="loading" />
    </Styled.Splash>
  );
};

export default Splash;
